import React, { createContext, useContext, useState, useEffect } from "react";
import ClientService from "../Services/clientService";

const ClientsContext = createContext();

export const ClientsProvider = ({ children }) => {
  const [clientsData, setClientsData] = useState([]);
  const [isFetchingClients, setIsFetchingClients] = useState(true);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    setIsFetchingClients(true);
    try {
      const fetchClientsData = await ClientService.GetClients();
      setClientsData(fetchClientsData);
    } catch (error) {
      console.error("Erreur lors du chargement des clients", error);
    } finally {
      setIsFetchingClients(false);
    }
  };

  const updateClient = async (id) => {
    const fetchClientCard = await ClientService.GetClient(id);
    setClientsData(
      clientsData.map((client) =>
        client.externalId === fetchClientCard.externalId ? { ...client, ...fetchClientCard } : client
      )
    );
  };

  return (
    <ClientsContext.Provider value={{ clientsData, updateClient, fetchClients, isFetchingClients }}>
      {children}
    </ClientsContext.Provider>
  );
};

export const useClients = () => useContext(ClientsContext);
